import helpManifest from "./help.manual.generated.json";

const sections = Array.isArray(helpManifest?.sections) ? helpManifest.sections : [];

const sectionsById = sections.reduce((accumulator, section) => {
  accumulator[section.id] = section;
  return accumulator;
}, {});

export function getHelpManifest() {
  return helpManifest;
}

export function getHelpSections() {
  return sections;
}

export function getHelpSection(id) {
  return sectionsById[id] || null;
}

export function getHelpTooltip(id) {
  const section = getHelpSection(id);
  if (!section) {
    return null;
  }

  return section.tooltip || section.summary || null;
}

function normalizeRoute(route) {
  if (!route) {
    return "";
  }

  const [pathname] = route.split(/[?#]/, 1);
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

function routeMatchesPattern(route, pattern) {
  const normalizedRoute = normalizeRoute(route);
  const normalizedPattern = normalizeRoute(pattern);

  if (!normalizedRoute || !normalizedPattern) {
    return false;
  }

  if (normalizedRoute === normalizedPattern) {
    return true;
  }

  const routeSegments = normalizedRoute.split("/").filter(Boolean);
  const patternSegments = normalizedPattern.split("/").filter(Boolean);

  if (routeSegments.length !== patternSegments.length) {
    return false;
  }

  return patternSegments.every((segment, index) => {
    if (segment.startsWith(":")) {
      return routeSegments[index].length > 0;
    }

    return segment === routeSegments[index];
  });
}

export function getHelpSectionsForRoute(route) {
  if (!route) {
    return [];
  }

  return sections.filter(
    (section) =>
      Array.isArray(section.routes) &&
      section.routes.some((pattern) => routeMatchesPattern(route, pattern))
  );
}

export function searchHelpSections(query) {
  const normalizedQuery = query?.trim().toLowerCase();

  if (!normalizedQuery) {
    return sections;
  }

  return sections.filter((section) => {
    const haystack = [
      section.id,
      section.title,
      section.summary,
      section.tooltip,
      section.contentMarkdown,
      ...(Array.isArray(section.keywords) ? section.keywords : []),
      ...(Array.isArray(section.body) ? section.body : []),
    ]
      .join(" ")
      .toLowerCase();

    return haystack.includes(normalizedQuery);
  });
}
